// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__rIDFr","content":"styles_content__1eqyG","checkbox":"styles_checkbox__NjOzv","checkboxLabel":"styles_checkboxLabel__1N6ya"};